import { Box, Container } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { Stepper } from '@/components/stepper'

import EditName from './steps/edit'
import FinishEdit from './steps/finish'
import { useStyles } from './styles'

const steps = {
  editname: { Component: EditName, index: 0 },
  finish: { Component: FinishEdit, index: 1 },
}

const stepsLabel = ['Informações básicas', 'Salvar dados']

const EditDiagnosis = () => {
  const classes = useStyles()

  const { step } = useParams<{ step: keyof typeof steps }>()

  const CurrentComponent = steps[step!]?.Component

  if (!CurrentComponent) return null

  return (
    <Box height='100%' minHeight='0' display='flex' flexDirection='column'>
      <Container className={classes.stepperContainer}>
        <Stepper activeStep={steps[step!]?.index} steps={stepsLabel} />
      </Container>

      <CurrentComponent />
    </Box>
  )
}

export default EditDiagnosis
